import Api from "@/services/Index";

const getFormData = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/staff/purchase-order-form/form");
};

const store = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/staff/purchase-order-form", data);
};

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/staff/purchase-order-form", config);
};

const getMyRequests = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/staff/purchase-order-form/my-requests", config);
};

const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/staff/purchase-order-form/" + id);
};

const sendToRequesterReview = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/staff/purchase-order-form/send-to-requester-review", data);
};

const sendToCfoOrPresidentReview = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/staff/purchase-order-form/send-to-cfo-or-president-review", data);
};

const purchaseOfficerApproval = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/staff/purchase-order-form/purchase-officer-approval", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

const download = async (uuid) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/staff/purchase-order-form/download/" + uuid, {
        responseType: "arraybuffer",
    });
};

export default {
    getFormData,
    store,
    getAll,
    getMyRequests,
    get,
    sendToRequesterReview,
    sendToCfoOrPresidentReview,
    purchaseOfficerApproval,
    download,
};
